export enum OrderStatusEnum {
  Created = 1,
  Uploaded,
  ToSign,
  Signed,
  ToLodge,
  Lodge,
  ToReport,
  Completed,
  Cancelled,
  Failed,
  NoSignature,
    DigitalSignature,
    ReadyToLodge,
  LodgeRequested,
}